import React from "react";

const TimeRangePicker = ({
  startTime = "",
  endTime = "",
  onStartChange,
  onEndChange,
  label,
  startLabel = "Start Time",
  endLabel = "End Time",
  hint,
  disabled = false,
  className = "",
}) => {
  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-3">
          {label}
        </label>
      )}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">
            {startLabel}
          </label>
          <input
            type="time"
            value={startTime}
            onChange={(e) => onStartChange(e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500"
            disabled={disabled}
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">
            {endLabel}
          </label>
          <input
            type="time"
            value={endTime}
            onChange={(e) => onEndChange(e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500"
            disabled={disabled}
          />
        </div>
      </div>
      {hint && <p className="text-xs text-gray-500 mt-2">{hint}</p>}
    </div>
  );
};

export default TimeRangePicker;
